module.exports = __webpack_public_path__ + "Roboto-RegularItalic.90dbf902b8d0592e1beb.ttf";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-RegularItalic.ttf
// module chunks = 16